import { Component } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'invalid-api-key-alert',
  standalone: true,
  templateUrl: './invalid-api-key.component.html',
  imports: [MatDialogModule, MatButtonModule]
})

export class InvalidAPIKeyComponent {}